
<template>
  <div>
    <v-row dense>
      <v-col cols="12" sm="6" v-if="payment.envelope_details.has_cash">
        <v-text-field
          v-model.lazy="payment.envelope_details.in_cash_aux"
          v-currency="currency"
          label="Valor recebido em dinheiro"
          prefix="R$"
          prepend-inner-icon="mdi-cash"
          :rules="[...required, ...notZero]"
          outlined
          dense
          hide-details="auto"
        ></v-text-field>
      </v-col>
      <v-col cols="12" v-if="payment.envelope_details.has_check">
        <v-stepper v-model="check_stepper" flat class="charge-stepper">
          <v-stepper-header class="elevation-0">
            <v-stepper-step :complete="check_stepper > 1" step="1" color="deep-orange darken-2"> Leitura dos CMC7 </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="check_stepper > 2" step="2" color="deep-orange darken-2"> Dados dos cheques </v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1" class="pt-2">
              <v-combobox
                clearable
                v-model="check_list"
                hide-selected
                return-masked-value
                hint="Leia ou digite o CMC7 e pressione Enter · máximo de 20 cheques"
                persistent-hint
                label="Códigos CMC7 dos cheques"
                prepend-inner-icon="mdi-barcode-scan"
                multiple
                outlined
                dense
              >
                <template v-slot:selection="data">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-chip :input-value="data.selected" v-on="on"  :color="checks_valid_array[data.index]? `green lighten-3` : 'red lighten-1'" @click="openCmc7Edit(data)">
                        <strong>{{ data.item }}</strong>&nbsp;
                      </v-chip>
                    </template>
                    <span>{{ checks_error_array[data.index] || "Cheque Válido" }}</span>
                  </v-tooltip>
                </template>
              </v-combobox>
              <v-dialog  v-if="dialogs.edit_cmc7" v-model="dialogs.edit_cmc7"   max-width="500px"  > 
                <v-card>
                  <v-card-title>
                    Editar CMC7
                  </v-card-title>
                  <v-card-text>
                    <v-form ref="editCmc7Form" @submit.prevent="confirmEditCmc7(edit_cmc7)">
                      <v-text-field v-model="edit_cmc7.item" :value="edit_cmc7.item" label="CMC7" :rules="[...cmc7]"></v-text-field>
                    </v-form>
                  </v-card-text>
                  <v-card-actions class="justify-end">
                    <f-btn @click="edit_cmc7={}; dialogs.edit_cmc7 = false" cancel></f-btn>
                    <v-btn color="primary" small :disabled="!validateCmc7(edit_cmc7.item).status" @click="confirmEditCmc7(edit_cmc7)"> Alterar </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <div class="d-flex justify-end mt-3">
                <v-btn color="deep-orange darken-2" depressed class="white--text" @click="getChecks()" :disabled="!checks_valid" small>
                  Avançar <v-icon right small>mdi-arrow-right</v-icon>
                </v-btn>
              </div>
            </v-stepper-content>
  
            <v-stepper-content step="2" class="pt-2">
              <div v-if="loading.cmc7_checks" class="text-center py-6">
                <v-progress-circular indeterminate color="deep-orange darken-2" class="mb-2"></v-progress-circular>
                <div class="body-2 grey--text">Carregando cheques...</div>
              </div>
              <template v-if="!loading.cmc7_checks">
                <div
                  v-if="payment.envelope_details.checks_attributes.length"
                  class="charge-sum-box charge-sum-box--ok d-flex justify-space-between align-center px-4 py-2 mb-3"
                >
                  <span class="caption font-weight-medium grey--text text--darken-2">
                    {{ payment.envelope_details.checks_attributes.length }}
                    {{ payment.envelope_details.checks_attributes.length === 1 ? 'cheque' : 'cheques' }}
                  </span>
                  <span class="subtitle-1 font-weight-bold deep-orange--text text--darken-2">
                    Total: {{ formatMoney(checks_total_value) }}
                  </span>
                </div>
                <v-expansion-panels multiple accordion class="charge-check-panels">
                  <v-expansion-panel v-for="(check, idx) in payment.envelope_details.checks_attributes" :key="`check-${idx}`">
                    <v-expansion-panel-header>
                      <div class="d-flex align-center">
                        <v-avatar size="26" color="deep-orange lighten-5" class="mr-2">
                          <span class="deep-orange--text text--darken-2 font-weight-bold caption">{{ idx + 1 }}</span>
                        </v-avatar>
                        <span class="subtitle-2">Cheque {{ idx + 1 }}</span>
                        <span class="caption grey--text ml-3" v-if="check.value_aux && check.value_aux != '0.00'">R$ {{ check.value_aux }}</span>
                        <v-spacer></v-spacer>
                        <v-btn v-if="idx > 0" icon small color="error" class="mr-2" @click.stop="removeCheck(idx)">
                          <v-icon small>mdi-delete-outline</v-icon>
                        </v-btn>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row dense :key="`check-${idx}`">
                        <v-col cols="12">
                          <v-text-field prepend-inner-icon="mdi-barcode" v-model="check.cmc7" :rules="[...required, ...cmc7]" label="CMC7" return-masked-value v-mask="'<########<##########>############:'" outlined dense hide-details="auto"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-autocomplete prepend-inner-icon="mdi-bank" label="Banco" :rules="[...required]" :items="all_banks" v-model.lazy="check.bank" item-text="name" item-value="name" outlined dense hide-details="auto"></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-text-field prepend-inner-icon="mdi-bank-outline" v-model="check.agency" label="Agência" :rules="[...required]" v-mask="'###############'" outlined dense hide-details="auto"></v-text-field>
                        </v-col>
                        <v-col cols="8">
                          <v-text-field prepend-inner-icon="mdi-numeric" v-model="check.account_number" label="Núm. conta" :rules="[...required]" outlined dense hide-details="auto"></v-text-field>
                        </v-col>
                        <v-col cols="4">
                          <v-text-field v-model="check.account_digit" label="Dígito" :rules="[...required]" v-mask="'##'" outlined dense hide-details="auto"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-text-field prepend-inner-icon="mdi-currency-brl" prefix="R$" v-model="check.value_aux" label="Valor" :rules="[...required, ...notZero]" v-currency="currency" outlined dense hide-details="auto"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-text-field prepend-inner-icon="mdi-pound" v-model="check.check_number" label="Núm. cheque" :rules="[...required]" outlined dense hide-details="auto"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-text-field prepend-inner-icon="mdi-account-outline" v-model="check.nominal" label="Nominal" :rules="[...required]" outlined dense hide-details="auto"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-menu
                            :value="good_to_open_idx === idx"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                            @input="onGoodToMenu(idx, $event)"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                prepend-inner-icon="mdi-calendar-range"
                                v-bind="attrs"
                                v-on="on"
                                :rules="[...required]"
                                :value="check.good_to ? $moment(check.good_to).format('L') : null"
                                label="Bom para"
                                readonly
                                outlined
                                dense
                                hide-details="auto"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="check.good_to"
                              color="deep-orange darken-2"
                              locale="pt-br"
                              scrollable
                              @input="good_to_open_idx = null"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="12" sm="5">
                          <v-radio-group v-model="check.cnpj_account" row dense hide-details class="mt-1">
                            <v-radio color="primary" label="Conta CNPJ" :value="true"></v-radio>
                            <v-radio color="error" label="Conta CPF" :value="false"></v-radio>
                          </v-radio-group>
                        </v-col>
                        <v-col cols="12" sm="7">
                          <v-text-field v-model="check.nominal_cpf" :rules="cpf" label="CPF Nominal" v-mask="'###.###.###-##'" v-if="check.cnpj_account == false" outlined dense hide-details="auto"></v-text-field>
                          <v-text-field v-model="check.nominal_cnpj" :rules="cnpj" label="CNPJ Nominal" v-mask="'##.###.###/####-##'" v-if="check.cnpj_account" outlined dense hide-details="auto"></v-text-field>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <div class="d-flex flex-wrap justify-space-between mt-3">
                  <v-btn text color="grey darken-1" @click="check_stepper = 1"><v-icon left small>mdi-arrow-left</v-icon> Voltar aos CMC7</v-btn>
                  <v-btn outlined color="deep-orange darken-2" @click="addCheck()"><v-icon left small>mdi-plus</v-icon> Cheque manual</v-btn>
                </div>
              </template>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {CurrencyDirective} from 'vue-currency-input'
import validations from '@/mixins/validations'
import Api from '@/api/index';
import { mask } from'vue-the-mask'
import status from "@/_backoffice/_financial/mixins/status.js"

export default {
  name: 'PaymentWithEnvelope',
  mixins: [ validations, status ],
  directives: {
    currency: CurrencyDirective,
    mask,
  },
  props: {
    payment: {
      type: Object,
    },
  },
  data() {
    return {
      currency:{
        currency: null,
        locale: 'en-EN',
        autoDecimalMode: true,
        decimalLength: 2,
        distractionFree:false,
      },
      check_list: [
        // "<75640335<0180048325>400000622514:" , "<75640337<0180048305>400000622514:"
      ],
      checks_valid_array: [],
      checks_error_array:[],
      checks_valid: false, 
      dialogs: {
        edit_cmc7: false,
      },
      loading:{
        cmc7_checks: false 
      },
      check_stepper: 1,
      good_to_open_idx: null,
      edit_cmc7:"",
      same_data: [],
      all_banks: [],
    }
  },
  computed: {
    checks_total_value() {
      const total = this.payment.envelope_details.checks_attributes.reduce(
        (sum, check) => sum + this.parseMoney(check.value_aux),
        0
      )
      return Number(total.toFixed(2))
    },
  },
  methods: {
    parseMoney(value) {
      if (typeof value === 'number') return Number.isFinite(value) ? value : 0
      const raw = String(value ?? '').trim()
      if (!raw) return 0
      const hasComma = raw.includes(',')
      const hasDot = raw.includes('.')
      if (hasComma && hasDot) {
        if (raw.lastIndexOf(',') > raw.lastIndexOf('.')) {
          return Number(raw.replace(/\./g, '').replace(',', '.')) || 0
        }
        return Number(raw.replace(/,/g, '')) || 0
      }
      if (hasComma) return Number(raw.replace(/\./g, '').replace(',', '.')) || 0
      return Number(raw) || 0
    },
    formatMoney(value) {
      return Number(value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    },
    confirmEditCmc7(data){
      if(this.$refs.editCmc7Form.validate()){
        if(this.check_list.includes(this.edit_cmc7.item)  ){
          this.check_list.splice(data.index, 1)
        }else{
          this.check_list.splice(data.index, 1,this.edit_cmc7.item)
        }
        this.edit_cmc7 ={}
        this.dialogs.edit_cmc7 = false
      }
    },
    copy_check_data(idx){
      if (this.same_data[idx]){
        const {good_to, value_aux, check_number, cmc7, ...ck} = this.payment.envelope_details.checks_attributes[0]
        this.payment.envelope_details.checks_attributes[idx] = {
          ...this.payment.envelope_details.checks_attributes[idx],
          ...ck
        }
      } else {
        this.payment.envelope_details.checks_attributes[idx].bank = null
        this.payment.envelope_details.checks_attributes[idx].agency = null
        this.payment.envelope_details.checks_attributes[idx].digit = null
        this.payment.envelope_details.checks_attributes[idx].account_number = null
        this.payment.envelope_details.checks_attributes[idx].account_digit = null
        this.payment.envelope_details.checks_attributes[idx].good_to = null
        this.payment.envelope_details.checks_attributes[idx].nominal = null
        this.payment.envelope_details.checks_attributes[idx].nominal_cpf = null
        this.payment.envelope_details.checks_attributes[idx].status_id = this.status_id_map['Payed']
        this.payment.envelope_details.checks_attributes[idx].cnpj_account = null
        this.payment.envelope_details.checks_attributes[idx].nominal_cnpj = null
      }
    },
    getChecks(){
      this.check_stepper = 2
      this.payment.envelope_details.checks_attributes = []
      this.loading.cmc7_checks = true
      Api.Check.indexCmc7(this.check_list)
      .then(r=>r.data).then(checks => {
        // retorna entidades de check inicializadas para serem criadas nested pelo payment
        this.payment.envelope_details.checks_attributes = [...checks.map(o=>{
          return {
            ...o,
            cnpj_account: o.nominal_cnpj? true: false,
            status_id: this.status_id_map['Payed'],
            value_aux: '0.00'
          }
        })]
        if (!checks.length){
          this.addCheck()
        }
      }).finally(()=>{
          this.loading.cmc7_checks = false
        })
    },
    addCheck(ck){
      if (!ck){
        this.swallConfirmation({
          title: 'Deseja copiar os dados do 1° cheque?',
          icon: 'question',
          cancelButtonText: 'Não',
          confirmButtonText: 'Sim',
        }).then( confirmed =>{
          if(confirmed){
            ck = {
              bank: this.payment.envelope_details.checks_attributes[0].bank,
              agency: this.payment.envelope_details.checks_attributes[0].agency,
              digit: null,
              account_number: this.payment.envelope_details.checks_attributes[0].account_number,
              account_digit: this.payment.envelope_details.checks_attributes[0].account_digit,
              good_to: null,
              nominal: this.payment.envelope_details.checks_attributes[0].nominal,
              nominal_cpf: this.payment.envelope_details.checks_attributes[0].nominal_cpf,
              status_id: this.status_id_map['Payed'],
              cnpj_account: this.payment.envelope_details.checks_attributes[0].cnpj_account,
              nominal_cnpj: this.payment.envelope_details.checks_attributes[0].nominal_cnpj,
              value_aux: '0.00',
              cmc7: null,
            }
            this.payment.envelope_details.checks_attributes = [...this.payment.envelope_details.checks_attributes, ck]
          }else{
            ck = {
              bank: null,
              agency: null,
              digit: null,
              account_number: null,
              account_digit: null,
              good_to: null,
              nominal: null,
              nominal_cpf: null,
              status_id: this.status_id_map['Payed'],
              cnpj_account: null,
              nominal_cnpj: null,
              value_aux: '0.00',
              cmc7: null
            }
            this.payment.envelope_details.checks_attributes = [...this.payment.envelope_details.checks_attributes, ck]
          }          
        });        
      }
    },
    removeCheck(idx){
      this.swallConfirmation({
          title: `Remover cheque ${Number(idx) + 1}?`,
          icon: 'question',
        }).then( confirmed =>{
          if(confirmed){
            this.payment.envelope_details.checks_attributes.splice(idx,1)
          }     
        });    
    },
    onGoodToMenu(idx, open){
      this.good_to_open_idx = open ? idx : (this.good_to_open_idx === idx ? null : this.good_to_open_idx)
    },
    openCmc7Edit(data){
      if(!this.checks_valid_array[data.index]){
        this.dialogs.edit_cmc7 = true
        this.edit_cmc7 = data
      }
    }, 
    validateCmc7(string){
      let regex = /(<\d{8}<\d{10}>\d{12}:?)/
      if (!string){
        return {status: false, error:"Campo deve ser válido"}
      }
      var result = string.match(regex)
      if(!result){
        return {status: false, error:"Código tem caracteres faltando"}
      }else {
        if(!this.verifyDigits(string)){
          return {status: false, error:"Dígitos verificadores não são válidos!"}
        }
      }
      return {status: true, error:""}
    },
    verifyDigits(string){
      let regex = /^<(\d{7})(\d)<(\d{10})>(\d)(\d{10})(\d):?/
      let result = string.match(regex)
      return  (
        this.VerifyMod10Digit(result[1], result[4]) &&
        this.VerifyMod10Digit(result[3], result[2]) &&
        this.VerifyMod10Digit(result[5], result[6]) 
      ) 
    },
    VerifyMod10Digit(number, digit){
      var i;
      var mult = 2;
      var sum = 0;
      var s = "";
      
      for (i=number.length-1; i>=0; i--){
        s = (mult * parseInt(number.charAt(i))) + s;
        if (--mult<1){mult = 2;}
      }
      for (i=0; i<s.length; i++)
        { sum = sum + parseInt(s.charAt(i)); }
      sum = sum % 10;
      if (sum != 0){sum = 10 - sum;}
      return (sum.toString() == digit)
    },
    getBanks(){
      Api.Bank.index().then(r=>r.data).then(b=>{
        this.all_banks = [...b.data.map(bb=> bb.attributes)]
      })
    },
  },
  mounted() {
    this.getBanks()
  },
  watch: {
    check_list (val, old) {
        let result = {status: true}
        val.forEach((v,idx) => {
          let r = this.validateCmc7(v)
          result.status = result.status && r.status
          this.checks_valid_array[idx] = r.status
          this.checks_error_array[idx] = r.error
          result.error = r.error                                                                                                                                                                                 
        })
        this.checks_valid = result.status
      if (val.length > 20) {
        this.$nextTick(() => this.check_list.pop())
      }
    },
  },
}
</script>

<style scoped>
.charge-stepper {
  border: 1px solid #e8eef3;
  border-radius: 12px !important;
}
.charge-check-panels ::v-deep .v-expansion-panel {
  border: 1px solid #e8eef3;
}
</style>
